<div class="approvers-group-container" *ngIf="!isLoadingLabels && !isLoadingSolutionAreas">
	<div *ngIf="showTableGroup">
		<cpi-msp-table
			[header]="searchHeader"
			[body]="iacAvailableApproversGroup"
			[height]="'55dvh'"
			[itemPadding]="'1%'"
			[labels]="labels"
			[insideSort]="true"
			(getSelectedItem)="getApproversGroupInfo($event[0].name)">
		</cpi-msp-table>

		<div class="button-container">
			<div class="button" (click)="openForm(true); clearInputs(false)">{{ labels.lbl_geral_novo }}/{{ labels.lbl_geral_editar }}</div>
		</div>
	</div>

	<div class="header-wrap" *ngIf="!showTableGroup && !showNewGroup">
		<span class="tab selected">{{ labels.lbl_grupo_aprovadores }}</span>
	</div>

	<div class="body-wrap" *ngIf="!showTableGroup && !showNewGroup">
		<ng-container *ngIf="!isLoadingApproversGroupInfo">
			<div class="dotted-input-container">
				<span>{{ labels.lbl_grupo_aprovadores }}</span>
				<input [value]="selectedApproverGroup" disabled />
			</div>
			<div>
				<cpi-generic-form-gen
					*ngIf="!isLoadingCustomers"
					[setGenericForm]="availableCustomersForm"
					[boldLabel]="false"
					[columns]="1"
					[labels]="labels"
					[columns]="2"
					[boldLabel]="true">
				</cpi-generic-form-gen>
			</div>
			<div>
				<cpi-generic-form-gen
					*ngIf="!isLoadingSolutionAreas"
					[setGenericForm]="availableSolutionAreaForm"
					[boldLabel]="false"
					[columns]="1"
					[labels]="labels"
					[columns]="2"
					[boldLabel]="true">
				</cpi-generic-form-gen>
			</div>
			<div>
				<cpi-generic-form-gen
					*ngIf="!isLoadingAvailableAnalysts"
					[setGenericForm]="availableAnalystsForm"
					[boldLabel]="false"
					[columns]="1"
					[labels]="labels"
					[columns]="2"
					[boldLabel]="true">
				</cpi-generic-form-gen>
			</div>

			<div class="dotted-input-container">
				<span>{{ labels.lbl_regra_aprovacao }}</span>
				<select (change)="groupSelectedConector = $event.target.value">
					<option [value]="'E'" [selected]="selectedApproverGroupObject.secondName === 'E'">
						{{ labels.lbl_todos_devem_aprovar }}
					</option>
					<option [value]="'OU'" [selected]="selectedApproverGroupObject.secondName === 'OU'">
						{{ labels.lbl_apenas_aprovacao }}
					</option>
				</select>
			</div>
			<div class="button-container mb-2">
				<div class="button" (click)="updateApproversGroup()" [ngClass]="{ disabled: isUpdatingApprovers }">
					{{ labels.lbl_atualizar_aprovadores }}
				</div>
				<div class="button" (click)="clearInputs(true)">{{ labels.lbl_geral_voltar }}</div>
			</div>
		</ng-container>
		<cpi-dot-bounce-loading-effect
			class="mt-2 ml-2"
			[color]="'var(--primary-color-1)'"
			*ngIf="isLoadingApproversGroupInfo"></cpi-dot-bounce-loading-effect>
		<div class="button-container"></div>
	</div>

	<div class="header-wrap" *ngIf="showNewGroup && !showTableGroup">
		<span class="tab selected">{{ labels.lbl_grupo_aprovadores }}</span>
	</div>

	<div class="body-wrap" *ngIf="showNewGroup && !showTableGroup">
		<div class="dotted-input-container">
			<span
				>{{ labels.lbl_grupo_aprovadores }}
				<fa-icon [icon]="icons.faInfoCircle" [title]="labels.lbl_editar_grupo_existente"></fa-icon
			></span>
			<select id="type" name="type" (change)="onGroupApprovalChange($event)">
				<option [value]="''" selected>{{ labels.lbl_geral_selecione }}</option>
				<option *ngFor="let option of groupApprovalsList" [value]="option.id">{{ option.group }}</option>
			</select>
		</div>

		<div class="dotted-input-container">
			<span>{{ labels.lbl_grupo_aprovadores }}*</span>
			<input id="status" name="status" type="text" [(ngModel)]="groupApprovalIntarface.group" />
		</div>

		<div class="dotted-input-container">
			<span>{{ labels.lbl_regra_aprovacao }}*</span>
			<select [(ngModel)]="groupApprovalIntarface.conector">
				<option [value]="''">{{ labels.lbl_geral_selecione }}</option>
				<option [value]="'E'">{{ labels.lbl_todos_devem_aprovar }}</option>
				<option [value]="'OU'">{{ labels.lbl_apenas_aprovacao }}</option>
			</select>
		</div>

		<div class="button-container">
			<div class="button" type="submit" (click)="validateForm()">{{ labels.lbl_geral_salvar }}</div>
			<div class="button" (click)="clearInputs(true)">{{ labels.lbl_geral_voltar }}</div>
		</div>
	</div>
</div>

<cpi-dot-bounce-loading-effect class="mt-2 ml-2" [color]="'var(--primary-color-1)'" *ngIf="isLoadingLabels"></cpi-dot-bounce-loading-effect>
